import React from "react";
import {
  ForgotPassword,
  IntroducerLogin,
} from "@quest-finance/quest-fe-shared/dist/auth";
import { PERMISSION_IAM } from "@quest-finance/quest-fe-shared/dist/iam/constants/permissions";
import { useNavigate } from "react-router";

export const IntroducerUserLogin = () => {
  const navigate = useNavigate();
  return (
    <IntroducerLogin
      onAuthSuccess={() => navigate("/application/applications")}
      source={PERMISSION_IAM["ACCESS.INTRODUCER_PORTAL"]}
      navigate={navigate}
    />
  );
};

export const ForgotPasswordPage: React.FC = () => {
  const navigate = useNavigate();
  return (
    <ForgotPassword
      source={PERMISSION_IAM["ACCESS.INTRODUCER_PORTAL"]}
      navigate={navigate}
    />
  );
};

export default IntroducerUserLogin;
